export const cookieOptions = {
  path: "/",
  domain: import.meta.env.VITE_CLICKNPARK_COOKIE_HOST,
  secure: import.meta.env.PROD,
};
